import React, {Component} from 'react';
import * as firebase from 'firebase';
import {ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';

export default class Charts2 extends Component {
  constructor() {
    super();
    this.state = {
      cahrts: [],
      displayName: ''
    }
  }
  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid
        const chartRef = firebase.database().ref('users/').child(userId).child('Answers')
        chartRef.once('child_added', snap => {
          var exists = (snap.val() !== null)
          if(exists) {
            var userId = firebase.auth().currentUser.uid
            const cmchart1Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('平和質(A型)');
            const cmchart2Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('氣虛質(B型)');
            const cmchart3Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('陽虛質(C型)');
            const cmchart4Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('陰虛質(D型)');
            const cmchart5Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('痰濕質(E型)');
            const cmchart6Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('濕熱質(F型)');
            const cmchart7Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('血瘀質(G型)');
            const cmchart8Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('氣鬱質(H型)');
            const cmchart9Ref = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('name').equalTo('特稟質(I型)');


            cmchart1Ref.on('child_added', snap => {
              this.setState({
                cm1ans: snap.val().ans
              })
            })
            cmchart2Ref.on('child_added', snap => {
              this.setState({
                cm2ans: snap.val().ans
              })
            })
            cmchart3Ref.on('child_added', snap => {
              this.setState({
                cm3ans: snap.val().ans
              })
            })
            cmchart4Ref.on('child_added', snap => {
              this.setState({
                cm4ans: snap.val().ans
              })
            })
            cmchart5Ref.on('child_added', snap => {
              this.setState({
                cm5ans: snap.val().ans
              })
            })
            cmchart6Ref.on('child_added', snap => {
              this.setState({
                cm6ans: snap.val().ans
              })
            })
            cmchart7Ref.on('child_added', snap => {
              this.setState({
                cm7ans: snap.val().ans
              })
            })
            cmchart8Ref.on('child_added', snap => {
              this.setState({
                cm8ans: snap.val().ans
              })
            })
            cmchart9Ref.on('child_added', snap => {
              this.setState({
                cm9ans: snap.val().ans
              })
            })
          } else {
            console.log('沒有輸入2')
          }
        })

      } else {
        window.location = ('/')
      }
    })
  }

  render() {
    const cmdata = [
       { name: '平和', 得分: this.state.cm1ans, fullMark: 150 },
       { name: '氣虛', 得分: this.state.cm2ans, fullMark: 150 },
       { name: '陽虛', 得分: this.state.cm3ans, fullMark: 150 },
       { name: '陰虛', 得分: this.state.cm4ans, fullMark: 150 },
       { name: '痰濕', 得分: this.state.cm5ans, fullMark: 150 },
       { name: '濕熱', 得分: this.state.cm6ans, fullMark: 150 },
       { name: '血瘀', 得分: this.state.cm7ans, fullMark: 150 },
       { name: '氣鬱', 得分: this.state.cm8ans, fullMark: 150 },
       { name: '特稟', 得分: this.state.cm9ans, fullMark: 150 },
    ]

    const chart3Box = this.state.cm1ans || this.state.cm2ans || this.state.cm3ans || this.state.cm4ans || this.state.cm5ans || this.state.cm6ans || this.state.cm7ans || this.state.cm8ans || this.state.cm9ans
     ? <div style={{height: 300}}>
        <ResponsiveContainer>
         <BarChart width={900} height={300} data={cmdata}
           margin={{top: 5, right: 10, left: -30, bottom: 5}}>
          <XAxis dataKey="name"/>
          <YAxis/>
          <CartesianGrid strokeDasharray="3 3"/>
          <Tooltip/>
          <Legend />
          <Bar dataKey="得分" fill="#325aaa" minPointSize={10} />
         </BarChart>
        </ResponsiveContainer>
       </div>
     : null

    return(
      <div>
       { chart3Box }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/charts3.js